import React from 'react';
import { useIntl } from 'react-intl';

import Currency from 'components/currency';
import { theme } from 'styles/configure-theme';

import { CurrencyLineSkeleton } from '../../currency-line-skeleton';

import { GrandTotalLabel, TotalsRow } from './styled';

const GrandTotalRow = TotalsRow.withConfig({
  marginTop: '$4',
});

interface GrandTotalProps {
  isLoading?: boolean;
  serverOrderTotalCents: number;
  serverOrderTip?: number;
  tipAmount: number;
  pickUpTips?: number;
}

const GrandTotal: React.FC<React.PropsWithChildren<GrandTotalProps>> = ({
  serverOrderTotalCents,
  serverOrderTip,
  tipAmount = 0,
  pickUpTips = 0,
  isLoading,
}) => {
  const { formatMessage } = useIntl();

  return (
    <GrandTotalRow>
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <GrandTotalLabel>
            {formatMessage({
              id: 'total',
            })}
            {'* '}
          </GrandTotalLabel>
          <Currency
            testID="grand-total"
            amount={serverOrderTotalCents - Number(serverOrderTip) + tipAmount + pickUpTips}
            isBold
            textProps={{
              color: theme.token('text-default'),
              margin: 0,
              flexGrow: 0,
            }}
          />
        </>
      )}
    </GrandTotalRow>
  );
};

export default GrandTotal;
